export default __webpack_public_path__ + "static/media/Group 148.01c742ee.png";